// extracted by mini-css-extract-plugin
export default {"cards":"Activites_cards__Icj5y","head":"Activites_head__I-rfR"};